document.addEventListener('DOMContentLoaded', function () {
  initAccordionToggles();
});

function initAccordionToggles() {
  const toggles = document.querySelectorAll('.accordion-toggle');

  toggles.forEach((toggle) => {
    // Prevent duplicate listeners
    toggle.removeEventListener('click', toggleAccordion);
    toggle.addEventListener('click', toggleAccordion);
  });
}

function toggleAccordion(event) {
  this.classList.toggle('active');
}

document.addEventListener('reinit-accordions', () => {
  initAccordionToggles();
});
